import { ApiError } from './api'

/**
 * Código nomeado de um erro da API.
 *
 * Existe porque decidir mensagem pelo STATUS é frágil: a quota (F5.3) e o rate
 * limiter respondem os dois 429, e são coisas diferentes. Quem estourou a quota
 * precisa ouvir "volte daqui a alguns dias"; quem bateu no limiter, "aguarde
 * alguns instantes". Tratar os dois como um só manda o primeiro tentar de novo
 * para sempre.
 *
 * Nunca lança: o corpo do erro vem da rede e pode ser qualquer coisa.
 */
export function api_error_code(err: unknown): string | null {
  if (!(err instanceof ApiError)) return null
  const body = err.body
  if (!body || typeof body !== 'object') return null
  const erro = (body as Record<string, unknown>).error
  if (!erro || typeof erro !== 'object') return null
  const code = (erro as Record<string, unknown>).code
  return typeof code === 'string' && code ? code : null
}
